import AnalyticsWebClient, {
  envType,
  tenantType,
  userType,
} from '@atlassiansox/analytics-web-client'
import jwtDecode from 'jwt-decode'

const environment = (() => {
  const { hostname } = window.location

  if (hostname.includes('.dev.services.') || hostname.includes('.stg.services.')) {
    return 'staging'
  }

  if (['localhost', 'atlastunnel'].some((domain) => hostname.includes(domain))) {
    // Change "development" to "local" to allow Sentry to send logs locally
    return 'development'
  }

  return 'production'
})()

function getAnalyticsEnv() {
  if (environment === 'staging') return envType.STAGING
  if (environment === 'production') return envType.PROD

  return envType.DEV
}

// default client
let client

function Init(aaid, product = 'openInSpreadsheet', subproduct = 'jiraSpreadsheets') {
  client = new AnalyticsWebClient(
    {
      env: getAnalyticsEnv(),
      product,
      subproduct,
      version: '1.0.0',
    },
    { useLegacyUrl: true },
  )

  client.setUserInfo(userType.ATLASSIAN_ACCOUNT, aaid)

  const cloudId = getCloudId()

  if (cloudId) {
    client.setTenantInfo(tenantType.CLOUD_ID, cloudId)
  }
}

function SendUIEvent(action, actionSubject, actionSubjectId, source, attributes = {}, tags = []) {
  client.sendUIEvent({ action, actionSubject, actionSubjectId, source, attributes, tags })
}

function SendScreenEvent(name, attributes = {}, tags = []) {
  client.sendScreenEvent({ name, attributes, tags })
}

async function OnInstallAddinClicked() {
  try {
    SendUIEvent('clicked', 'button', 'installAddin', 'openInExcelScreen')
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Unable to send event:', e)
  }
}

function getCloudId() {
  try {
    const jwt = new URLSearchParams(window.location.search).get('jwt')

    if (!jwt) return

    return jwtDecode(jwt)?.context?.cloudId
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Unable to get cloudId', error)
  }
}

export { Init, SendUIEvent, SendScreenEvent, OnInstallAddinClicked }
